module.exports = __webpack_public_path__ + "img/inventoryManagement.77d72396.svg";